module.exports = __webpack_public_path__ + "img/yiliaofuwu.7e767ff6.png";